// TradingProtectedRoute.jsx
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import useAccessProfile from "../hooks/useAccessProfile";
import { isTradingRestricted, hasRole } from "../utils/accessControl";

export default function TradingProtectedRoute({ redirectTo = "/inspection" }) {
  const { currentUser } = useAuth();
  const { profile, loading } = useAccessProfile();
  const navigate = useNavigate();

  if (loading) return null;

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  const tradingRestricted = isTradingRestricted(profile);
  const isAdmin = hasRole(profile, "admin");

  if (tradingRestricted && !isAdmin) {
    // Show a friendly access message with a button instead of silently redirecting

    return (
      <div style={{ padding: 40, maxWidth: 760, margin: "60px auto", textAlign: "center" }}>
        <h2>Access Restricted</h2>
        <p style={{ color: "#374151", marginTop: 8 }}>
          Trading is disabled for operational staff accounts to prevent conflict of interest.
        </p>
        <div style={{ marginTop: 18 }}>
          <button
            onClick={() => navigate("/inspection")}
            style={{ marginRight: 12, padding: "10px 14px", borderRadius: 8, background: "#0369a1", color: "white", border: "none" }}
          >
            Go to Inspection Queue
          </button>
          <button
            onClick={() => navigate("/")}
            style={{ padding: "10px 14px", borderRadius: 8, background: "#f3f4f6", border: "1px solid #e5e7eb" }}
          >
            Back to Marketplace
          </button>
        </div>
      </div>
    );
  }

  return <Outlet />;
}